import bellIcon from '~/assets/icons/bell.svg';
import lightIcon from '~/assets/icons/light.svg';
import settingsIcon from '~/assets/icons/settings.svg';
import soundIcon from '~/assets/icons/sound.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Switch } from '~/components/ui/Switch';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { SettingsStages } from '../../models/Settings';
import { setActiveSettingsState, useLayoutDispatch } from '../../redux';
import {
	StyledContainer,
	StyledImage,
	StyledInfoNameContainer,
	StyledPlayerInfoContainer,
	StyledSettingsItem,
	StyledSettingsItemIcon,
	StyledSettingsList,
} from './AppSettingsMain.styled';

const AppSettingsMain = () => {
	const dispatch = useLayoutDispatch();
	const phoneSettings = useObservable(rage.phone.getSettings());
	const nickname = useObservable(rage.player.getNickname());

	const handleSettingsItemClick = (item: SettingsStages) => {
		dispatch(setActiveSettingsState(item));
	};

	return (
		<StyledContainer>
			<StyledPlayerInfoContainer>
				<StyledImage />
				<StyledInfoNameContainer>
					<Text>{nickname}</Text>
					{/* <Text>
						<span>Тел.: </span>
						{phoneNumber}
					</Text> */}
				</StyledInfoNameContainer>
			</StyledPlayerInfoContainer>
			<StyledSettingsList>
				<StyledSettingsItem
					onClick={() => {
						handleSettingsItemClick(SettingsStages.GLOBAL);
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					<StyledSettingsItemIcon $bgColor="rgba(177, 177, 177, 0.6)">
						<img src={settingsIcon} />
					</StyledSettingsItemIcon>
					<Text>Основные настройки</Text>
				</StyledSettingsItem>
				<StyledSettingsItem
					onClick={() => {
						handleSettingsItemClick(SettingsStages.SCREEN);
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					<StyledSettingsItemIcon $bgColor="#0066FF">
						<img src={lightIcon} />
					</StyledSettingsItemIcon>
					<Text>Экран / Обои</Text>
				</StyledSettingsItem>
				<StyledSettingsItem>
					<StyledSettingsItemIcon $bgColor="#E4582D">
						<img src={bellIcon} />
					</StyledSettingsItemIcon>
					<Text>Уведомления</Text>
					<Switch
						value={phoneSettings.notificationsEnabled}
						onChange={(value) => {
							rage.phone.setNotificationsEnabled(value);
						}}
					/>
				</StyledSettingsItem>
				<StyledSettingsItem>
					<StyledSettingsItemIcon $bgColor="#D40035">
						<img src={soundIcon} />
					</StyledSettingsItemIcon>
					<Text>Звуки</Text>
					<Switch
						value={phoneSettings.soundsEnabled}
						onChange={(value) => {
							rage.phone.setSoundsEnabled(value);
						}}
					/>
				</StyledSettingsItem>
			</StyledSettingsList>
		</StyledContainer>
	);
};

export { AppSettingsMain };
